import { render, staticRenderFns } from "./AutoDetail.vue?vue&type=template&id=34c732ee&scoped=true"
import script from "./AutoDetail.vue?vue&type=script&lang=js"
export * from "./AutoDetail.vue?vue&type=script&lang=js"
import style0 from "./AutoDetail.vue?vue&type=style&index=0&id=34c732ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c732ee",
  null
  
)

export default component.exports